import { createSlice } from "@reduxjs/toolkit";

const initialUsers = {
    isLoggedIn: false,
    // False until /api/user has answered. Guarded pages use this to avoid
    // flashing "access denied" at an admin who is still being authenticated.
    authChecked: false,
    username: "",
    name: "",
    surname: "",
    email: "",
    role: "",
    gender: "",
    token: null,
    phone: "",
    language: "geo",
    balance: "",
    debt: "",
    id: "",
    identity_number: ""
}

const user = createSlice({
    name: "users",
    initialState: initialUsers,
    reducers: {
        changeIsLoggedIn(state, action){
            state.isLoggedIn = action.payload
        },
        setAuthChecked(state, action){
            state.authChecked = action.payload
        },
        saveUserData(state, action){
            state.balance = action.payload.balance;
            state.email = action.payload.email;
            state.id = action.payload.id;
            state.identity_number = action.payload.identity_number;
            state.last_login_time = action.payload.last_login_time;
            state.last_purchase_date = action.payload.last_purchase_date;
            state.name = action.payload.name;
            state.phone = action.payload.phone;
            state.role = action.payload.role;
            state.signup_date = action.payload.signup_date;
            state.surname = action.payload.surname;
            state.username = action.payload.username;
            state.debt = action.payload.debt;
        },
        setToken(state, action){
            state.token = action.payload;
        },
        setLanguage(state, action){
            state.language = action.payload;
        }
    }
})

export const usersActions = user.actions;

export default user.reducer